<template lang="pug">
app-dialog(v-model="dialogEditEvent" width="880" :header="eventDialogHeader")
  .event
    app-date-picker(v-model="selectedDate" view-format="DD.MM.YYYY")

    app-text-field(v-model="name" label="Название" counter="255" outline clearable)
    app-text-field(v-model="place" label="Место" counter="255" outline clearable)

    v-layout
      v-flex(xs4 mr-2)
        app-select(v-model="timeStart" :items="startIntervals" label="Начало") 
      v-flex(xs4 mr-2)
        app-select(v-model="duration" :items="timeIntervals" label="Продолжительность") 
      v-flex(xs4)
        app-select(v-model="period" :items="periods" label="Периодичность") 
        
    app-tags-combobox(v-model="tags" :items="allTags")

    v-textarea(v-model="notes" label="Комментарий" outlined light)
    
    .event-form__row.event-form__row--buttons
      v-btn.text-none(v-if="isEventExist" dark color="#ED0E51" text large @click="dialogDelEvent=true") Удалить
      v-spacer
      v-btn.text-none.event-action(color="#1B93AD" :disabled="!isReady" large depressed @click="save") Далее

    app-dialog-confirm(v-model="dialogDelEvent" @confirm="remove()")
      app-card-title.mt-5 
        b Вы точно хотите удалить событие - 
        | {{name}} ?

</template>


<script>
import { mapGetters, mapState } from 'vuex'
import { AppDialogConfirm } from '@/components'
import moment from 'moment'
moment.locale('ru')

const periods = ['единожды', 'ежедневно', 'ежедневно (кроме сб, вс)', 'еженедельно', 'ежемесячно', 'ежегодно']

export default {
  props: {
    event
  },

  components: { [AppDialogConfirm.name]: AppDialogConfirm },

  data () {
    return {
      id: null,
      name: null,
      place: null,
      notes: null,
      eventDate: moment(),
      tags: [],
      timeStart: null,
      duration: null,
      period: null,
      periods,
      newTag: null,
      dialogEditEvent: false,
      dialogDelEvent: false,
    }
  },

  mounted () {
   if (this.event) this.updateForm(this.event)
  },

  watch: {
    event (newValue) {
      this.updateForm(newValue)
    },

    selectedEventTime () {
      this.updateForm(this.event)
      this.dialogEditEvent = true
    }
  },


  computed: {
    ...mapState('event', ['selectedEventTime']),
    ...mapGetters('event', ['allTags']),

    selectedDate: {
      get () {
        return this.eventDate.format('YYYY-MM-DD')
      },
      set (value) {
        this.eventDate = moment(value)
      }
    },

    computedDateFormatted () {
      return moment(this.eventDate).format('DD MMMM YYYY')
    },

    startIntervals () {
      var list = []
      for (var i = 8; i < 20; i++) {
        let hour = `0${i}`.slice(-2)
        list.push(`${hour}:00`)
        list.push(`${hour}:30`)
      }
      return list
    },

    timeIntervals () {
      var list = ['00:30']
      for (var i = 1; i < 12; i++) {
        let hour = `0${i}`.slice(-2)
        list.push(`${hour}:00`)
        list.push(`${hour}:30`)
      }
      return list
    },

    isEventExist () {
      return this.event && this.event.id
    },

    selectedTags () {
      return [...new Set(this.tags)].map(item => this.makeTagObject(item))
    },

    startEventDate () {
      let times = this.timeStart.split(':')
      let date = moment(this.eventDate).clone()
      return date.hours(times[0]).minutes(times[1]).format('YYYY-MM-DD HH:mm')
    },

    formEvent () {
      return {
        id: this.id,
        name: this.name,
        notes: this.notes,
        place: this.place,
        periodic: null,
        durability: moment.duration(this.duration).asMinutes(),
        eventDate: this.startEventDate,
        eventTags: this.selectedTags,
      }
    },

    eventDialogHeader () {
      return this.selectedEvent && this.selectedEvent.id ? 'Просмотр события' : 'Добавить событие'
    },

    isReady () {
      let nameIsOk = this.name && this.name.length > 0 && this.name.length <= 255
      let placeIsOk = this.place == null || this.place.length == 0 || this.place.length <= 255
      let timeStartIsOk = this.timeStart && this.timeStart.length > 0
      return nameIsOk && placeIsOk && timeStartIsOk
    },
  },


  methods: {
    makeTagObject (tag) {
      return tag instanceof Object ? tag : this.allTags.find(x => x.name === tag) || { name: tag }
    },

    save () {
      let actionPath = this.id ? 'event/editEvent' : 'event/createEvent'
      this.$store.dispatch(actionPath, this.formEvent)
      .then(() => {
        this.dialogEditEvent = false
      })
    },

    remove () {
      this.$store.dispatch('event/removeEvent', this.event)
      .then(() => {
        this.dialogEditEvent = false
      })
    },

    updateForm (newValue) {
      let duration = newValue.durability ? newValue.durability : 60
      let hours = Math.floor(duration / 60)
      let minutes = duration % 60
      
      if (hours < 10) hours = '0' + hours
      if (minutes < 10) minutes = '0' + minutes

      this.duration = `${hours}:${minutes}`

      this.name = newValue.name
      this.place = newValue.place
      this.notes = newValue.notes
      this.period = newValue.periodic

      this.eventDate = moment(newValue.eventDate) || moment()

      let start = this.eventDate.format('HH:mm')
      this.timeStart = this.startIntervals.includes(start) ? start : this.startIntervals[0]
      
      this.tags = null
      this.tags = newValue.eventTags ? newValue.eventTags.map(t => t.name) : []

      this.id = newValue ? newValue.id : null
    }
  }
}
</script>


<style lang="scss" scoped>
.event-action {
  margin: 0px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;

  color: #FFFFFF;
}
.event-form {
  max-width: 1000px;

  &__form {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  &__input {
    margin-bottom: 10px;
  }

  &__row {
    display: flex;
    flex-direction: row;
    align-content: stretch;

    &--buttons {
      justify-content: space-between;
    }
  }

  &__row-input {
    margin-right: 10px;
    flex-wrap: nowrap !important;

    &:last-child {
      margin-right: 0;
    }
  }
}
.sud-event-form-picker {
  flex: 1;
}
</style>

<style>
.sud-event-form-time-dropdown {
  z-index: 60000000 !important;
}
.sud-event-form-tag {
  border-color: transparent;
  color: black
}
.sud-hidden {
  display: none;
}
body.budza .sud-event-form-select .el-tag,
body.budza .sud-event-form-select .el-tag--info {
  color: black !important;
  border-color: transparent !important;

}
body.budza .sud-event-form-select .el-tag__close {
  color: black !important;
}
.sud-event-form-select-tags {
  background-color: #f0f0f0 !important;
}
</style>

